export const userModel = {
  userCode: null,
  userName: '',
  entityCode: null,
  accessOptions: [],
  platform: null,
};

export const accessOptionsByUser = (accessOptions, allAccessOptions) => {
  return accessOptions
    .map((option) => {
      const optionFound = allAccessOptions.find(
        (value) => value.optionCode === option.optionCode
      );
      if (optionFound) {
        const { icon, path } = optionFound || {};
        const children = option.children
          ? option.children.map((item) => {
              const childrenFound =
                optionFound.items &&
                optionFound.items.find(
                  (itemChildren) => item.optionCode === itemChildren.optionCode
                );
              return { ...item, path: childrenFound?.path };
            })
          : undefined;
        return { ...option, icon, path: path, children };
      }
    })
    .filter((value) => value !== undefined);
};
